import { history } from '../store';

export const goBack = () => history.goBack();

export const push = (path: string, params?: any) => history.push(path, params);

export const replace = (path: string, params?: any) => history.replace(path, params);
